import "./styles.css";

const Submit = ({
  path = "",
  left = "",
  submit,
  icon = "fa fa-credit-card",
}) => {
  return (
    <div>
      {/*path && (
        <Link className="btn btn-default" to={path}>
          <i className="fa fa-angle-left" /> &nbsp;{left}
        </Link>
      ) path && <span>|</span>*/}

      <button type="submit" className="submit">
        <div>
          <i className={icon} />
          <span>{submit}</span>
          <i className="fa fa-angle-right" />
        </div>
      </button>
    </div>
  );
};

export default Submit;
